import React from 'react';
import styled from 'styled-components';
import { Modal, ModalProps } from '~web/view/components/layout/modal.component';
import { Column } from '~common/components/column.component';
import { onSmallPhoneMediaQuery, onTabletMediaQuery } from '~web/view/theme/utils';

export interface DialogProps extends ModalProps {}

export const Dialog: React.FunctionComponent<DialogProps> = ({
  children,
  disableBackdropClick,
  backdropColor,
  onCancel,
  onShow,
  ...rest
}) => {
  return (
    <Modal
      disableBackdropClick={disableBackdropClick}
      backdropColor={backdropColor}
      onCancel={onCancel}
      onShow={onShow}
    >
      <Container {...rest}>{children}</Container>
    </Modal>
  );
};

const Container = styled(Column)`
  max-width: 90%;
  max-height: 100%;
  align-items: center;
  background: ${(props): string => props.theme.colors.gray.v6};
  border: 1px solid ${(props): string => props.theme.colors.gray.v3};
  box-sizing: border-box;
  border-radius: 16px;
  padding: 70px 40px;
  margin: 0 16px;
  ${onTabletMediaQuery} {
    max-width: 400px;
  }
  ${onSmallPhoneMediaQuery} {
    padding: 32px 24px;
  }
`;



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/view/components/layout/dialog.component.tsx